// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import axios from 'axios';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import '@/utils/axios';

import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/index.css'                 // global css
import '@/assets/css/element-ui.css'

import hrymd5 from '@/utils/hrymd5';
import _cookie from '@/utils/cookie';

Vue.use(ElementUI);
Vue.prototype.$ajax = axios;
Vue.prototype.hrymd5 = hrymd5;
Vue.prototype.COOKIE = _cookie;

Vue.config.productionTip = false;

router.beforeEach((to,from,next)=>{
    //路由发生变化时候修改meta中的content
    if (to.meta.content) {
        let head = document.getElementsByTagName('head');
        let meta = document.createElement('meta');
        document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords);
        document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description);
        meta.content = to.meta.content;
        head[0].appendChild(meta);
    }

  /*路由发生变化修改页面title*/
  if(to.meta.title){
    document.title = to.meta.title
  }else if(to.query.title){
    document.title = to.query.title
  }
  if(to.path === '/login'){
    // next();
    router.push("/");
    store.commit('ChangeLoginShow');
  }else if(to.path === '/register'){
    router.push("/");
    store.commit('ChangeRegisShow');
  }else {
    if(to.meta.requireAuth && !localStorage.getItem('token')) {
      localStorage.clear();
      router.push("/");
      store.commit('ChangeLoginShow');
    }else {
      next();
    }
  }
});
router.afterEach((to,from,next) => {
  window.scrollTo({
      top: 0,
      behavior: "instant"
  });
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js